import { Add, ArrowDropDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { useRef, useState } from "react";
import { useSfdcAuthentication } from "../hooks/useSfdcAuthentication";
import { useSfdcIntegrations } from "../hooks/useSfdcIntegrations";

export const SalesforceIntegrationButton: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { integrations } = useSfdcIntegrations();
  const existingOrgNames = integrations.map((integration) => integration.name);

  const authenticateProduction = useSfdcAuthentication({
    isProdEnv: true,
    orgNames: existingOrgNames,
  });

  const authenticateSandbox = useSfdcAuthentication({
    isProdEnv: false,
    orgNames: existingOrgNames,
  });

  const handleProductionClick = () => {
    setIsMenuOpen(false);
    authenticateProduction();
  };

  const handleSandboxClick = () => {
    setIsMenuOpen(false);
    authenticateSandbox();
  };

  return (
    <div>
      <Button
        data-testid="salesforce-connect-btn"
        ref={buttonRef}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        variant="contained"
        endIcon={<ArrowDropDown />}
        sx={{
          borderRadius: "30px",
        }}
      >
        Connect Salesforce
      </Button>
      <Menu
        open={isMenuOpen}
        anchorEl={buttonRef.current}
        onClose={() => setIsMenuOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPaper-root": {
            minWidth: 200,
          },
        }}
      >
        <MenuItem
          data-testid="salesforce-connect-prod-menuitem"
          sx={{ display: "flex", gap: 1 }}
          onClick={handleProductionClick}
        >
          <Add sx={{ color: "gray" }} />
          Add Production Org
        </MenuItem>
        <MenuItem
          data-testid="salesforce-connect-sandbox-menuitem"
          sx={{ display: "flex", gap: 1 }}
          onClick={handleSandboxClick}
        >
          <Add sx={{ color: "gray" }} />
          Add Sandbox Org
        </MenuItem>
      </Menu>
    </div>
  );
};
